module.exports = __webpack_public_path__ + "static/media/GreenLightText.39bdd3ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/rlgl/Logo/svg/GreenLightText.svg
// module id = 423
// module chunks = 0